export enum DriverStatus {
  PENDING_DRIVER = "PENDING_DRIVER",
  PENDING_DISPATCHER = "PENDING_DISPATCHER",
  APPROVED = "APPROVED",
  REJECTED = "REJECTED",
}

const OnBoardingConstant = {
    ON_BOARDING_CONSTANT: {
      TABLE_WRAPPER_DATA: {
        title: "Driver Onboarding",
        HeaderData: [
          { field: "userId", headerName: "Driver ID", width: 120 },
          { field: "firstName", headerName: "First Name", width: 180 },
          { field: "lastName", headerName: "Last Name", width: 180 },
          { field: "vehicleType", headerName: "Vehicle Type", width: 150,
            filter: true,
            filterObj: {
              type: "autocomplete",
              fieldKey: "vehicleType",
              fieldName: "vehicleType",
              fieldFullName: "vehicleType",
              multiple: true,
              key: `autoComplete-vehicleType`,
              label: "Vehicle Type",
              items: [],
            },
          },
          {
            field: "submissionDate",
            headerName: "Submission Date",
            width: 170,
            filter: true,
            filterObj: {
              type: "dateRange",
              fieldKey: "submissionDate",
              fieldName: "dateRange",
              key: `dateRange-filter`,
              placeholderText: "submission Date",
              label: "submission Date",
              autoUpdateInput: false,
              autoApply: true,
              showDropdowns: true,
              linkedCalendars: true,
              maxSpan: {
                month: "1",
              },
              locale: {},
            },
          },
          {
            field: "status",
            headerName: "Status",
            width: 130,
            filter: true,
            filterObj: {
              type: "autocomplete",
              fieldKey: "status",
              fieldName: "status",
              fieldFullName: "status",
              multiple: true,
              key: `autoComplete-status`,
              label: "Status",
              items: [],
            },
          },
        ],
        headerButtons: [],
        loadMore: { name: "loadMore", disabled: false, pageSize: 20 },
        defaultFiltersObj: {
          dateRange: {
            key: "dateRange",
            value: {
              startDate: new Date(),
              endDate: new Date(),
            },
          },
          status: {
            key: "status",
            value: [],
            fieldName: "status",
          },
          vehicleType: {
            key: "vehicleType",
            value: [],
            fieldName: "vehicleType",
          },
        },
        SEARCH_TYPES: [
          { name: "Driver ID", value: "userId" },
        ],
      },
    },
  };

  export default OnBoardingConstant;
